class BESSAppProjectDwellingsProfilerManager extends BESSAppProjectProfilerManager {

    constructor(profiler) {
        super(profiler);
        this.#updateTotals();
    }


    updated() {
        super.updated();
        this.#updateTotals();
    }

    #updateTotals() {
        this.totalDwellings = 0;
        this._forEachItem(this.#updateTotalsForItem);

        let totalsContent =
            this._createTotalItemContent(this.totalDwellings, this.profiler.data.getWhat(this.totalDwellings)) +
            this._createTotalItemContent(this.profiler.data.items.length,
                pluralise(this.profiler.data.what + " group",
                    this.profiler.data.what + " groups",
                    this.profiler.data.items.length));

        this.profiler.showTotals(totalsContent);
    }

    #updateTotalsForItem(item) {
        let quantity = item.values[this.profiler.data.getFieldNoForAttribute('quantity')].value;
        if (quantity === null || quantity === undefined) {
            quantity = 0;
        }

        this.totalDwellings += quantity;
    }

}